import styled from '@emotion/styled';
import classNames from 'classnames';
import React from 'react';

const ScrollableDiv = styled.div<{ maxHeight, baseColor }>`
  background:
    /* Shadow Cover TOP */ linear-gradient(${({baseColor}) => baseColor} 30%, rgba(255, 255, 255, 0)) center top,
    /* Shadow Cover BOTTOM */ linear-gradient(rgba(255, 255, 255, 0), ${({baseColor}) => baseColor} 70%) center bottom,
    /* Shadow TOP */ radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, 0.2) 10px, rgba(0, 0, 0, 0)) center
      top,
    /* Shadow BOTTOM */ radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.2) 10px, rgba(0, 0, 0, 0))
      center bottom;
  background-repeat: no-repeat;
  background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
  background-attachment: local, local, scroll, scroll;
  display: block;
  max-height: ${({ maxHeight }) => maxHeight ?? 'auto'};
  overflow-y: scroll;
`;

const DesignGridWrapper = ({ children, maxHeight = 'auto', className = '', baseColor = 'white' }) => {
  return (
    <ScrollableDiv className={classNames(className)} maxHeight={maxHeight} baseColor={baseColor}>
      {children}
    </ScrollableDiv>
  );
};

export default DesignGridWrapper;
